export const getUrl = (url: string, prefix = '/api/archiwum') => {
  const isProd = process.env.NODE_ENV === 'production';
  /*global API_URL*/
  /*global API_URL_TEST*/
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return `${isProd ? API_URL : API_URL_TEST}${prefix}/${url}`;
};
